var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 22.5078H7.75V35H0.71875V0.875H13.3984C17.4297 0.875 20.5391 1.77344 22.7266 3.57031C24.9141 5.36719 26.0078 7.90625 26.0078 11.1875C26.0078 13.5156 25.5 15.4609 24.4844 17.0234C23.4844 18.5703 21.9609 19.8047 19.9141 20.7266L27.2969 34.6719V35H19.75L13.3516 22.5078ZM7.75 16.8125H13.4219C15.1875 16.8125 16.5547 16.3672 17.5234 15.4766C18.4922 14.5703 18.9766 13.3281 18.9766 11.75C18.9766 10.1406 18.5156 8.875 17.5938 7.95312C16.6875 7.03125 15.2891 6.57031 13.3984 6.57031H7.75V16.8125Z",
    fill: "url(#paint0_linear_6_102)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_102",
    x1: 14.0078,
    y1: 0.875,
    x2: 14.0078,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.d51173b83995d861ab9973edf8655b4e.svg";
export { ForwardRef as ReactComponent };